import { Link } from 'react-router-dom';
import type { Wish, ApiWish } from '../../types';
import './WishCard.css';

interface WishCardProps {
  wish: Wish | ApiWish;
  onClick?: (wishId: string) => void;
}

const WishCard = ({ wish, onClick }: WishCardProps) => {
  const handleClick = (e: React.MouseEvent) => {
    // If onClick is provided and we're on desktop, use modal instead of navigation
    if (onClick && window.innerWidth >= 768) {
      e.preventDefault();
      onClick(wish.id);
    }
  };

  const getCategoryLabel = (category: string) => {
    const labels: Record<string, string> = {
      '維修': '汽車維修',
      '保養': '汽車保養',
      '美容': '汽車美容',
      '改裝': '汽車改裝',
    };
    return labels[category] || category;
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return '未知';

    const date = new Date(dateString);
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '未知';
    }

    return date.toLocaleDateString('zh-TW', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };

  return (
    <Link to={`/wishes/${wish.id}`} className="wish-card" onClick={handleClick}>
      <div className="wish-card__header">
        <h3 className="wish-card__title">{wish.title}</h3>
        {wish.urgent && (
          <span className="wish-card__urgent-badge">急件</span>
        )}
      </div>

      {wish.description && (
        <p className="wish-card__description">{wish.description}</p>
      )}

      <div className="wish-card__meta">
        <div className="wish-card__meta-item">
          <span className="wish-card__label">地區：</span>
          <span>{wish.region}</span>
          {wish.district && <span> ({wish.district})</span>}
        </div>

        <div className="wish-card__meta-item">
          <span className="wish-card__label">類別：</span>
          <span>{getCategoryLabel(wish.category)}</span>
        </div>

        {wish.budget && (
          <div className="wish-card__meta-item">
            <span className="wish-card__label">預算：</span>
            <span>NT${wish.budget}</span>
          </div>
        )}

        <div className="wish-card__meta-item">
          <span className="wish-card__label">發布者：</span>
          <span>{wish.userName || '匿名'}</span>
        </div>
      </div>

      <div className="wish-card__footer">
        <div className="wish-card__status">
          <span className={`wish-card__status-badge wish-card__status-badge--${wish.status}`}>
            {wish.status === 'open' && '尋找中'}
            {wish.status === 'matched' && '配對中'}
            {wish.status === 'closed' && '已結案'}
          </span>
        </div>
        <div className="wish-card__date">
          {formatDate(wish.createdAt)}
        </div>
      </div>
    </Link>
  );
};

export default WishCard;
